import React from 'react';
import {
  screenSmMin,
  screenMdMin,
  screenLgMin,
  screenXlMin,
} from '@spotify-internal/encore-foundation';

export enum Viewport {
  XS = 'XS',
  SM = 'SM',
  MD = 'MD',
  LG = 'LG',
  XL = 'XL',
}

const smQuery = window.matchMedia(`(min-width: ${screenSmMin})`);
const mdQuery = window.matchMedia(`(min-width: ${screenMdMin})`);
const lgQuery = window.matchMedia(`(min-width: ${screenLgMin})`);
const xlQuery = window.matchMedia(`(min-width: ${screenXlMin})`);

const defaultQueries: Queries = {
  smQuery,
  mdQuery,
  lgQuery,
  xlQuery,
};

type Queries = {
  smQuery: MediaQueryList;
  mdQuery: MediaQueryList;
  lgQuery: MediaQueryList;
  xlQuery: MediaQueryList;
};

export function getMatch(queries: Queries) {
  let v = Viewport.XS;
  if (queries.smQuery.matches) v = Viewport.SM;
  if (queries.mdQuery.matches) v = Viewport.MD;
  if (queries.lgQuery.matches) v = Viewport.LG;
  if (queries.xlQuery.matches) v = Viewport.XL;
  return v;
}

export const useViewport: (queries?: Queries) => Viewport = (queries = defaultQueries) => {
  const [viewport, setViewport] = React.useState(() => getMatch(queries));
  const handleResize = () => setViewport(getMatch(queries));

  React.useEffect(() => {
    handleResize();
    queries.smQuery.addListener(handleResize);
    queries.mdQuery.addListener(handleResize);
    queries.lgQuery.addListener(handleResize);
    queries.xlQuery.addListener(handleResize);
    return () => {
      queries.smQuery.removeListener(handleResize);
      queries.mdQuery.removeListener(handleResize);
      queries.lgQuery.removeListener(handleResize);
      queries.xlQuery.removeListener(handleResize);
    };
  }, []);

  return viewport;
};
